import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function TopLists() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Explore curated top lists of luxury lifestyle experiences on First-Class.com. Find inspiration for your next upscale adventure'
          }
        />
        <title>
          Lifestyle Toplists: Ranking the Best Luxury Lifestyle Choices
        </title>
      </Head>
      <ArticlesList
        subtype="Toplists"
        type="Lifestyle"
        heading="Finest Selection"
      />
    </>
  );
}

export default withLayout(TopLists, true);
